import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import "./styles/global.css"; // 引入全局样式

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);
